import {
  LOAD_OPERATIONS_DATA,
  LOAD_CONSUMER_API_DATA,
  LOAD_DATAQUEST_DATA,
  LOAD_SHOGUN_DATA,
  LOAD_MONITORING_DATA
} from '../constants';

export const receiveOperationsData = (data) => ({
  type: LOAD_OPERATIONS_DATA,
  data
})

export const receiveConsumerApiData = (data) => ({
  type: LOAD_CONSUMER_API_DATA,
  data
})

export const receiveDataquestData = (data) => ({
  type: LOAD_DATAQUEST_DATA,
  data
})

export const receiveShogunData = (data) => ({
  type: LOAD_SHOGUN_DATA,
  data
})

export const receiveMonitoringData = (data) => ({
  type: LOAD_MONITORING_DATA,
  data
})


// WEBPACK FOOTER //
// ./src/admin/statuses/javascripts/actions/statusesActions.js